import React from "react";

const nodeHeight = (target: string | React.RefObject<HTMLElement>) => {
  if (typeof target === "string") {
    return (
      ((document.querySelector(target) as HTMLElement) || null)?.offsetHeight ||
      0
    );
  }
  return target.current.offsetHeight;
};

export default nodeHeight;
